import React, { useEffect, useState } from 'react';
import '../../Assets/CSS/Enquiries.css';
import { Link, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios';
import { use } from 'react';
import { getCookie } from '../../components/auth/login/GetCookie';

const Enquiries = ({ setActiveTab, setSelectedEnquiry }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10); // [10, 25, 50, 100, setRowsPerPage]
    const [loading, setLoading] = useState(true);
    const [EnquiriesData, setEnquiriesData] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [showmodel, setShowModel] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    // const { id } = useParams();


    useEffect(() => {

        fetchData();
    }, [fromDate, toDate, currentPage]);

    const fetchData = async () => {
        try {
            const params = {
                pageNumber: currentPage - 1,
                pageSize: 10,
            };
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            if (!token) {
                console.error('Token not found');
                return;
            }
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiries`, {
                headers: { Authorization: `Bearer ${token}` },
                params
            });
            const data = response.data.content;
            console.log(response.data.content.productEnquiryId, '=======eid');
            console.log(response.data.content.productId, "=====pid");

            console.log(data);
            setEnquiriesData(data);
            setTotalPages(response.data.totalPages)
            setLoading(false);
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleViewDetail = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setActiveTab("viewDetail");
    };
    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const currentRows = EnquiriesData.slice(indexOfFirstRow, indexOfLastRow)
    // const totalPages = Math.ceil(EnquiriesData.length / rowsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };
    const confirmDelete = (productId) => {
        setDeleteId(productId);
        setShowModel(true);
    }
    const handleDelete = async (productId) => {

        // Handle delete logic here
        try {
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            if (!token) {
                console.error('Token not found');
                return;
            }
            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiry/${productId}`, {
                headers: { Authorization: `Bearer ${token}` }
                ,
            });
            if (response.status === 200) {
                console.log('Item deleted successfully');
                setEnquiriesData((prevData) => prevData.filter((item) => item.productId !== productId));
            } else {
                console.error('Failed to delete item');
            }
        } catch (error) {
            console.error('Error deleting item:', error);
            if (error.response && error.response.status === 404) {
                console.error('Item not found');
            }
            else {
                console.error('Error deleting item:', error);
            }
        }
        finally {
            setLoading(false);
            console.log(`Delete item with ID: ${productId}`);
        }



    }
    const skeletonRows = Array.from({ length: 5 });
    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='d-flex justify-content-between align-content-between'>
                <h5 className='heading-enquiries'>Enquiries : </h5>
                <div className='d-flex'>
                    <div className="row g-5">
                        {/* From Date */}
                        <div className="col-md-6">
                            <label htmlFor="fromDate" className="form-label"
                                style={{
                                    position: 'absolute',
                                    right: "330px",
                                    top: "12px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#FDC400",
                                    zIndex: "2",
                                    padding: "0 5px",
                                    background: "white",

                                }}>From</label>
                            <div className="input-group custom-input-group">
                                <input
                                    type="date"
                                    id="fromDate"
                                    className="form-control required"
                                    placeholder="Select start date"
                                    style={{
                                        cursor: 'pointer',
                                        position: 'relative',
                                        zIndex: "1"

                                    }}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />

                            </div>
                        </div>

                        {/* To Date */}
                        <div className="col-md-6">
                            <label htmlFor="toDate" className="form-label"
                                style={{
                                    position: 'absolute',
                                    right: "150px",
                                    top: "12px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#FDC400",
                                    background: "white",
                                    zIndex: "2",
                                    padding: "0 5px",
                                }}>To</label>
                            <div className="input-group custom-input-group">
                                <input
                                    type="date"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="Select end date"
                                    style={{
                                        cursor: 'pointer',
                                        position: 'relative',
                                        zIndex: "1"
                                    }}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setToDate(e.target.value)}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className='mt-4 row'>
                <div className='col-md-12'>
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="table-headings  px-2"
                                style={{ verticalAlign: "middle", background: " #fffbea" }}>

                                <th className="table-head  py-2 ps-2"> ID</th>
                                <th className="table-head py-2 ps-2">Buyer Name</th>
                                <th className="table-head  py-2 ps-2">Product name</th>
                                <th className="table-head py-2 ps-3">Date</th>
                                <th className="table-head  py-2 ps-3 text-end">Action</th>
                                <th className='px-4'></th>

                                <th></th>
                            </thead>
                            <tbody>

                                {loading
                                    ? skeletonRows.map((_, i) => (
                                        <tr key={i}>
                                            {Array.from({ length: 6 }).map((_, j) => (
                                                <td key={j} className="py-2">
                                                    <div
                                                        style={{
                                                            height: '16px',
                                                            background: '#e0e0e0',
                                                            borderRadius: '4px',
                                                            width: j === 2 ? '60%' : '80%',
                                                            animation: 'pulse 1.5s infinite',
                                                        }}
                                                    ></div>
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                    : EnquiriesData.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-4 text-muted">No Enquiry</td>
                                        </tr>
                                    ) : EnquiriesData.map((row, index) => (
                                        <tr key={index}>
                                            <td className='py-2'>{index + 1}</td>
                                            <td className='py-2'>{row.buyerName.slice(0, 6)}</td>
                                            <td className='py-2'>{row.productName.slice(0, 10)}...</td>
                                            <td className='py-2'>
                                                {new Date(row.enquiryCreatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                            </td>

                                            <td className='py-2'>
                                                <Link
                                                    onClick={() => handleViewDetail(row.productEnquiryId)}
                                                // to={`/admin/enquiries/detailenquiries/${row.productId}`}
                                                >
                                                    <button className="view-detail-btn px-3 py-1 "
                                                    >View</button>
                                                </Link>
                                            </td>
                                            <td>
                                                <Link>
                                                    <button className="delete-btn px-2 py-1 ms-2"
                                                        onClick={() => confirmDelete(row.productId)}>Delete</button>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='d-flex justify-content-between'>
                        {/* show rows per page */}
                        <div className='d-flex align-items-center'>
                            {/* <h6 className='me-2'>Show</h6>
                            <select className='form-select' onChange={(e) => setRowsPerPage(e.target.value)}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={20}>20</option>
                            </select> */}
                        </div>
                        {/* Pagination Buttons */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <span className='me-2'>{currentPage} of {totalPages}  </span>
                            <button className="btn" onClick={handlePrev} disabled={currentPage === 1}
                                style={{ color: '#FDC400' }}
                            >

                                <Icon icon="grommet-icons:previous" />
                            </button>

                            <button className="btn ms-2 " onClick={handleNext} disabled={currentPage === totalPages}
                                style={{ color: '#FDC400' }}
                            >
                                <Icon icon="grommet-icons:next" />
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            {/* Modal */}
            {showmodel && (
                <div className="modal show d-block d-flex justify-content-center align-items-center"
                    style={{
                        boxShadow: ' 0px 4px 6px 0px #00000026',
                        background: '#000000B2'
                    }}>
                    <div className="modal-dialog">
                        <div className="modal-content pt-4">
                            <div>
                                <Icon icon='material-symbols-light:close'
                                    className='close-btn fs-5'
                                    onClick={() => setShowModel(false)}>

                                </Icon>
                            </div>
                            <h5 className="pt-4 fw-bold fs-5 px-5">Delete Enquiry Confirmation</h5>

                            <p className='px-5 fw-normal fs-6 '
                                style={{ color: '#606060' }}>Are you sure you want to delete this enquiry from <br />
                                the list? This action cannot be undone.</p>

                            <div className="d-flex justify-content-center align-item-center gap-4 mt-4 mb-4">
                                <button className="rounded-5 border cancelbtn px-5"
                                    onClick={() => setShowModel(false)}>Cancel</button>
                                <button className="px-5 rounded-5 border py-1"
                                    style={{
                                        background: '#CB3B2A',
                                        color: ' #FFFFFF'
                                    }}
                                    onClick={handleDelete}>Yes, Delete</button>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default Enquiries;


